import { Container, Row, Col, Card } from "react-bootstrap";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { logo } from "../static";
import { FaGavel, FaLightbulb, FaAward, FaUsers, FaShieldAlt, FaHandHoldingHeart } from 'react-icons/fa';

const Sobre = () => {
    const valores = [
        { icon: <FaShieldAlt />, titulo: "Integridade", desc: "Atuamos com ética, honestidade e transparência. A confiança dos nossos clientes é sustentada por uma conduta exemplar." },
        { icon: <FaGavel />, titulo: "Perícia", desc: "Apostamos na excelência técnica e formação contínua para oferecer soluções jurídicas seguras e inovadoras." },
        { icon: <FaAward />, titulo: "Excelência e Qualidade", desc: "Entregamos resultados com rigor analítico, precisão e compromisso com a perfeição." },
        { icon: <FaUsers />, titulo: "Colaboração", desc: "Valorizamos o trabalho em equipa, promovendo sinergia e partilha de conhecimentos entre advogados e parceiros." },
        { icon: <FaLightbulb />, titulo: "Objectividade e Independência", desc: "Agimos com discernimento e imparcialidade, garantindo aconselhamento justo e orientado à verdade jurídica." },
        { icon: <FaHandHoldingHeart />, titulo: "Responsabilidade Social", desc: "Contribuímos para uma sociedade mais justa por meio de ações pro bono, inclusão e responsabilidade cidadã." }
    ];

    return (
        <>
            <Navbar />
            <main style={{ backgroundColor: "#fdfcf9" }}>
                {/* --- HEADER DA PÁGINA --- */}
                <section 
                    className="py-5 position-relative overflow-hidden" 
                    style={{ backgroundColor: "#2c2219", color: "#f4f1ea", minHeight: "40vh", display: "flex", alignItems: "center" }}
                >
                    <div 
                        className="position-absolute w-100 h-100"
                        style={{
                            top: 0, left: 0,
                            backgroundImage: `url(${logo})`,
                            backgroundSize: '40px 40px',
                            backgroundRepeat: 'repeat',
                            opacity: 0.03,
                            zIndex: 1
                        }}
                    />
                    <Container className="position-relative text-center" style={{ zIndex: 2 }}>
                        <h6 className="text-uppercase fw-bold mb-3" style={{ color: "#c5a47e", letterSpacing: "3px" }}>Conheça a Nossa Firma</h6>
                        <h1 className="display-4 fw-bold" style={{ fontFamily: "'Playfair Display', serif" }}>Sobre Nós</h1>
                        <p className="lead mx-auto opacity-75 mt-3" style={{ maxWidth: "800px" }}>
                            Conheça a essência da Paul Rodney & Associados — uma sociedade de advogados dedicada à excelência, ética e inovação jurídica.
                        </p>
                    </Container>
                </section>

                {/* --- MISSÃO E VISÃO --- */}
                <Container className="py-5 my-5">
                    <Row className="gy-5 align-items-center">
                        <Col lg={6}>
                            <div className="pe-lg-5">
                                <h2 className="mb-4" style={{ color: "#2c2219", fontFamily: "'Playfair Display', serif" }}>Nossa Missão</h2>
                                <p style={{ textAlign: "justify", lineHeight: "1.8", color: "#4a4a4a" }}>
                                    A missão da <strong>Paul Rodney & Associados</strong> consiste em prestar serviços jurídicos de excelência, pautados pela integridade e pela perícia técnica, agregando valor real aos clientes. 
                                    Buscamos soluções jurídicas sólidas e inovadoras que protejam os interesses dos nossos clientes e promovam o desenvolvimento sustentável dos negócios e do Estado de Direito em Angola e nos demais países onde actuamos.
                                </p>
                                <p className="fst-italic fw-bold" style={{ color: "#c5a47e", fontSize: "1.1rem" }}>
                                    “Integritas et Peritia”
                                </p>
                            </div>
                        </Col>
                        <Col lg={6} style={{ backgroundColor: "#2c2219", padding: "3rem", color: "#f4f1ea" }}>
                            <h2 className="mb-4" style={{ color: "#c5a47e", fontFamily: "'Playfair Display', serif" }}>Nossa Visão</h2>
                            <p style={{ textAlign: "justify", lineHeight: "1.8" }} className="opacity-90">
                                A visão da firma é ser reconhecida como uma sociedade de advogados de referência em Angola, em África e nos mercados internacionais onde operamos. 
                                Almejamos consolidar-nos como a firma full-service angolana de excelência, combinando profundo conhecimento local com padrões internacionais de qualidade.
                            </p>
                            <p className="mb-0 opacity-90">
                                Pretendemos expandir a nossa presença de forma estratégica, tornando-nos numa ponte entre o mundo jurídico de língua portuguesa e inglesa.
                            </p>
                        </Col>
                    </Row>
                </Container>

                {/* --- NOSSOS VALORES --- */}
                <section className="py-5" style={{ backgroundColor: "#f4f1ea" }}>
                    <Container>
                        <div className="text-center mb-5">
                            <h6 className="text-uppercase fw-bold" style={{ color: "#c5a47e", letterSpacing: "2px" }}>O que nos guia</h6>
                            <h2 className="display-5 fw-bold" style={{ color: "#2c2219", fontFamily: "'Playfair Display', serif" }}>Nossos Valores</h2>
                        </div>
                        <Row className="g-4">
                            {valores.map((item, index) => (
                                <Col md={6} lg={4} key={index}>
                                    <Card className="h-100 border-0 shadow-sm p-4 text-center valor-card" style={{ transition: "0.3s", backgroundColor: "#fff" }}>
                                        <div className="mb-3 fs-1" style={{ color: "#c5a47e" }}>
                                            {item.icon}
                                        </div>
                                        <h5 className="fw-bold mb-3" style={{ color: "#2c2219" }}>{item.titulo}</h5>
                                        <p className="small text-muted mb-0" style={{ lineHeight: "1.6" }}>{item.desc}</p>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </Container>
                </section>
            </main>
            <Footer />

            <style>{`
                .valor-card:hover {
                    transform: translateY(-10px);
                    box-shadow: 0 15px 30px rgba(44, 34, 25, 0.1) !important;
                }
                h2 { position: relative; }
            `}</style>
        </>
    );
};

export default Sobre;